const privacy = {
    header: [
        "수집목적",
        "항목",
        "기간"
    ],
    body: [
        {
            td: {
                text: "서비스 이용에 필요한 본인 식별"
            },
            td1: {
                text: "성명(닉네임), 회원ID(이메일주소와 동일), 비밀번호"
            },
            td2: {
                text: "회원 탈퇴 시 즉시 파기",
                rowSpan: 5,
            },

        },
        {
            td: {
                text: "연령에 따른 이용 제한"
            },
            td1: {
                text: "만 14세 미만 여부"
            },
        },
        {
            td: {
                text: "고지사항 전달, 본인의사 확인, 불만처리 등 원활한 의사소통 및 새로운 서비스, 이벤트 정보의 안내,"
            },
            td1: {
                text: "회원ID(이메일주소와 동일)"
            },
        },
        {
            td: {
                text: "업데이트 정보, 이벤트 소식, 결제내역 등의 이메일 수신여부 확인"
            },
            td1: {
                text: "메일수신여부(뉴스레터, 결제내역)"
            },
        },
        {
            td: {
                text: "서비스 이용 기록 분석, 부정이용 방지 등을 위한 기록 관리"
            },
            td1: {
                text: "서비스 이용기록, 접속 로그, 쿠키, 접속IP정보, 결제기록, 이용 정지 기록, 모바일 기기정보(OS/앱버전), 브라우저 정보"
            },
        }
    ],
    text: `이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다.
    회원가입 시 수집하는 최소한의 개인정보, 즉, 필수 항목에 대한 수집 및 이용 동의를 거부하실 경우,
    회원가입이 어려울 수 있습니다.`
};

const privacyOptional = {
    header: [
        "수집목적",
        "항목",
        "기간"
    ],
    body: [
        {
            td: {
                text: "참고용 정보 확보"
            },
            td1: {
                text: "성별, 직종, 사용용도, 추천인"
            },
            td2: {
                text: "회원 탈퇴 시 즉시 파기 또는 이용 목적 달성 즉시 파기",
                rowSpan: 3,
            },

        },
        {
            td: {
                text: "이벤트, 경품제공시 참여자 적합성 확인 및 배송을 위한 정보 확보"
            },
            td1: {
                text: "연락처, 주소"
            },
        }
    ],
}


export default { privacy, privacyOptional }